import moment from "moment";
import Vue from "vue";

Vue.filter("date", (date: string) => {
  return moment(date).format("MM-DD-YYYY");
});
